import type { SupplierLookupPaginatedResponse } from '../types/supplier-lookup-paginated-response.type';
import { PaginatedResponseModel } from './paginated-response.model';
import { SupplierLookupModel } from './supplier-lookup.model';

export class SupplierLookupPaginatedResponseModel
  extends PaginatedResponseModel
  implements SupplierLookupPaginatedResponse
{
  readonly items: SupplierLookupModel[] | null = null;
  readonly name: string | null;

  constructor(data: SupplierLookupPaginatedResponse) {
    super(data);

    this.name = data.name;

    if (data.items) {
      this.items = data.items.map((item) => new SupplierLookupModel(item));
    }
  }
}
